import React, { useEffect } from 'react';
import { Modal, Icon, Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPEPRepresentative, fetchPEPRepresentativeFilter, pepRepresentativeClear, pepRepresentativeClearFilter } from 'app/actions/PEPRepresentativeActions';
import { getPEPRepresentative, getPEPRepresentativeFilter, getIsLoadingPEPRepresentative } from 'app/reducers';
import IconButton from '@material-ui/core/IconButton';
import ApiService from 'app/services/ApiService';
import { setTimeout } from 'timers';
import isEmpty from 'app/utils/IsEmpty';

export default function PEPRepresentativeTableContainer(props) {
    const { classes } = props;
    const { confirm } = Modal;

    const pagination = props.pagination;
    const sorter = props.sorter;
    let offset = 0;
    let limit = 0;
    let column = null;
    let order = null;

    const {
        siteId
    } = useSelector(state => state.Auth);

    const columns = [
        {
            title: 'Nombre',
            dataIndex: 'responsibleName',
            key: 'responsibleName',
            sorter: true,
            width: 300,
            ellipsis: true

        },
        {

        },
        {
            title: 'Acciones',
            key: 'action',
            dataIndex: 'idResponsible',
            fixed: 'right',
            width: 120,
            render: (text, record) => (
                <div className={classes.buttons}>
                    {siteId === 'HUB' ?
                        <Tooltip placement="bottom" title={'Eliminar'}>
                            <IconButton className={classes.deleteIcon} onClick={() => showConfirmDelete(record)}>
                                <Icon type="delete" />
                            </IconButton>
                        </Tooltip>
                        : null
                    }

                    <Tooltip placement="bottom" title={siteId === 'HUB' ? 'Editar' : 'Visualizar'}>
                        <IconButton className={classes.editIcon} onClick={() => showEdit(record)}>
                            <Icon type={siteId === 'HUB' ? 'edit' : 'eye'} />
                        </IconButton>
                    </Tooltip>

                </div>
            )
        }
    ];

    const showEdit = (param) => {
        props.isVisibleForm(true);
        props.setIdResponsible(param.idResponsible);
        props.setNameResponsible(param.responsibleName);
    }

    const showConfirmDelete = (param) => {
        confirm({
            title: '¿Eliminar Representante PEP?',
            content: param.responsibleName,
            okText: 'Eliminar',
            okType: 'danger',
            cancelText: 'Cancelar',
            onOk() {
                props.setFiltroNombre(props.FiltroNombre.filter(x => x !== param.responsibleName));
                return deleteResponsible(param);
            },
            onCancel() { },
        });

    }

    async function deleteResponsible(param) {
        await ApiService.deleteResponsible(param.idResponsible).then(res => {
            dispatch(pepRepresentativeClear());
            dispatch(pepRepresentativeClearFilter());
            dispatch(fetchPEPRepresentativeFilter({ idRol: 4 }))
            dispatch(fetchPEPRepresentative({
                responsibleName: props.FiltroNombre.filter(x => x !== param.responsibleName).join(','),
                idRol: 4,
                sortColumn: column,
                sortDir: order,
                offset: offset, limit: limit
            }));
            const modal = Modal.success({
                title: `Eliminado Correctamente`,
                content: '',
            });

            setTimeout(function () {
                modal.destroy();
            }, 3000)

        });
    }

    let sspaRepresentative = useSelector(getPEPRepresentative);
    let sspaRepresentativeFilter = useSelector(getPEPRepresentativeFilter);

    let isLoading = useSelector(getIsLoadingPEPRepresentative);
    const dispatch = useDispatch();

    useEffect(() => {
        if (isEmpty(sspaRepresentative)) fetchPEPRepresentativeAction();
        if (isEmpty(sspaRepresentativeFilter)) fetchPEPRepresentativeFilterAction();
    }, []);

    const handleTableChange = (pagination, filters, sorter) => {

        props.setPagination(pagination);
        props.setSorter(sorter);
        if (Object.keys(sorter).length > 0) {
            column = sorter.field;
            order = sorter.order === "ascend" ? "ASC" : "DESC";
        }
        else {
            column = '';
            order = '';
        }

        dispatch(fetchPEPRepresentative(
            {
                responsibleName: props.FiltroNombre.join('|'),
                idRol: 4,
                sortColumn: column,
                sortDir: order,
                offset: ((pagination.current - 1) * pagination.pageSize),
                limit: pagination.pageSize
            }));
    };

    //Load
    if (pagination != null) {
        offset = (0 * pagination.pageSize);
        limit = (pagination.pageSize);

        if (!isLoading && sspaRepresentative.length > 0) {
            pagination.total = sspaRepresentative[0].totalcount;
        }
        else {
            pagination.total = 0;
        }
    }

    if (sorter != null) {
        column = sorter.field;
        order = sorter.order === "ascend" ? "ASC" : "DESC";
    }



    const fetchPEPRepresentativeAction = () => dispatch(fetchPEPRepresentative({
        responsibleName: props.FiltroNombre !== undefined ? props.FiltroNombre.join(',') : '',
        idRol: 4,
        sortColumn: column,
        sortDir: order,
        offset: offset, limit: limit
    }));
    const fetchPEPRepresentativeFilterAction = () => dispatch(fetchPEPRepresentativeFilter({ idRol: 4 }))
    return (props.children({ pagination: pagination, cols: columns, sspaRepresentative, sspaRepresentativeFilter, isLoading, handleTableChange: handleTableChange }));
}

